import React from 'react';
import _ from 'lodash';

import NewEntry from './NewEntry';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Loader from '../../Components/Loader';
import BackButton from '../../Components/BackButton';
import LoaderButton from '../../Components/LoaderButton';

import { Fields } from './NewEntry';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

import { connect } from 'react-redux'
import { doLoad, doPut, select } from '../../Redux/Actions'
import store from '../../Redux';

const ENDPOINT = "users"

const styles = theme => ({

})

class DetailObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        putLoading: false
    }

    componentDidMount() {
        this.props.doLoad(this.props.match.params.id)
        this.unsubscribe = store.subscribe(() => {

                var generic = select(store.getState(), ENDPOINT)
                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }

                if(this.state.newEntry.id === undefined) {
                    this.setState({
                        newEntry: generic.data
                    })
                }

                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }

                if(_.has(generic, "putLoading") && this.state.putLoading !== generic.putLoading) {
                    if(_.has(generic.putLoading, this.state.newEntry.id)) {
                        this.setState({
                            putLoading: generic.putLoading[this.state.newEntry.id]
                        })
                    }
                }

            }
        )
    }

    render() {

        var { classes } = this.props
        var { newEntry, isLoading, dialogOpen, newEntry } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var {
            vorname, name
        } = newEntry

        return (
            <div>

                <Toolbar>
                    <BackButton history={this.props.history} href={"/" + ENDPOINT} />
                    <div className={classes.flex} />
                    {name}
                </Toolbar>

                <Card>
                    <CardContent>
                        <Fields handleChangeSelect={this.handleChangeSelect} handleChange={this.handleChange} {...newEntry} />
                    </CardContent>
                    <CardActions className="cardAction">
                        <LoaderButton name="Speichern" color="primary" onClick={this.saveData} loading={this.state.putLoading} />
                    </CardActions>
                </Card>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (id, filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/single/" + id, filter)),
    doPut: (id, data) => dispatch(doPut(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DetailObject));



// WEBPACK FOOTER //
// ./src/Routes/User/Detail.js